var map = {
	"./1.jpg": 182,
	"./1212663-200.png": 5458,
	"./196-1962589_testimonials-messenger-icon-png-black-transparent-png.png": 133,
	"./2.jpg": 5087,
	"./3.jpg": 6797,
	"./5.jpg": 2321,
	"./6.jpg": 8991,
	"./7.gif": 4823,
	"./BriefCase.svg": 5578,
	"./Employment.svg": 2111,
	"./Energy.svg": 7323,
	"./Law.png": 6099,
	"./Law.svg": 4959,
	"./Light.svg": 6790,
	"./Litigation.svg": 9266,
	"./Logo2.png": 637,
	"./Policy.svg": 6326,
	"./Policy2.svg": 675,
	"./Probate.svg": 7846,
	"./RealEstate.svg": 5728,
	"./Testimony.svg": 8136,
	"./blog.jpg": 6226,
	"./blog2.1.jpg": 3,
	"./blog3.1.jpg": 2525,
	"./blog4.1.jpg": 7904,
	"./blog5.jpg": 398,
	"./blog6.jpg": 4362,
	"./blog7.jpg": 3982,
	"./blog8.jpg": 6293,
	"./britam2.jpg": 305,
	"./business.svg": 1769,
	"./civil.svg": 7865,
	"./contact.jpg": 4223,
	"./env.svg": 6921,
	"./family.svg": 9333,
	"./logo.jpg": 5096,
	"./logo.svg": 9574,
	"./prof.jpg": 3100,
	"./prof1.jpg": 9339,
	"./prof2.jpg": 8326,
	"./prof3.jpg": 5186,
	"./prof4.jpg": 895,
	"./w.jpg": 9547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 327;